import { createContext } from 'react';

// Light/dark toggle. Provided in main.jsx; consumed by the Header theme switch.
export const ColorModeContext = createContext({ mode: 'light', toggle: () => {} });
